import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, Button, FormLabel } from '@material-ui/core';
import { func, object, number } from 'prop-types';

import { getI18n } from '../../../utils/intl';

export const BulkDeleteUsers = (props) => {
    const {
      classes = {},
      bulkActionsItemsCount,
      onBulkDelete,
    } = props;
    const id = 'bulk-delete-users'
    const intl = getI18n(useIntl());
  
    const onClickDelete = () => {
        onBulkDelete()
    };
  
    return (
      <>
          <Grid item md={12} sm={12} xs={12}>
            <FormLabel>
              {`${intl.getI18nMessage('label.user.actions')} (${bulkActionsItemsCount} ${intl.getI18nMessage('label.items.selected')})`}
            </FormLabel>
          </Grid>
         <Grid item md={12} sm={12} xs={12}>
          <Button
            variant="contained" color="secondary"
            className={classes.deleteUsersButton}
            id={`${id}-delete`} data-apim-test={`${id}-delete`} data-layer7-test={`${id}-delete`}
            onClick={onClickDelete}
            disabled={false}
            >
            {intl.getI18nMessage('label.users.delete')}
          </Button>
      </Grid>
      </>
    );
  }
  
  BulkDeleteUsers.propTypes = {
    classes: object,
    bulkActionsItemsCount: number,
    onBulkDelete: func,
  };
  
  export default (props) => (
    <BulkDeleteUsers
      {...props}
    />
  );
  